import axios from 'axios';
import { useCurrentUser } from 'hooks/useCurrentUser';
import { useQuery } from 'react-query';
import { MAX_PAGE_SIZE } from 'utils/constants';
import { normalizeJSONAPIResponse } from 'utils/modelUtils';

// TODO: consolidate with useGetCourses
const getCourses = async (_key: string, partnerId: string) => {
  let allCourses: any[] = [];
  let currentPage = 1;
  let totalPages = 1;

  do {
    const response = await axios.get(
      `/api/v4/partners/${partnerId}/courses?limited=true&page[number]=${currentPage}&page[size]=${MAX_PAGE_SIZE}&status_filter=all&sort=-last_updated`
    );
    allCourses.push(...normalizeJSONAPIResponse(response.data));
    totalPages = response.data.meta?.['total-pages'] ?? 1;
    currentPage++;
  } while (currentPage <= totalPages);

  return allCourses;
};

export const useCourses = () => {
  const user = useCurrentUser();
  const partner = user?.primaryPartner;

  return useQuery(['courses', partner.id], getCourses, {
    enabled: partner,
  });
};
